var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4 6L8 10L12 6","stroke":"#000","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ChevronDown.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
